import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

export const useTracking = (trackingId = "G-XXE9Y4G4G0") => {
  const { listen } = useHistory();

  useEffect(() => {
    const unlisten = listen((location, action) => {
      if (!window.gtag) return;
      if (!trackingId) {
        console.log(
          "Tracking not enabled, as `trackingId` was not given and there is no `GA_MEASUREMENT_ID`."
        );
        return;
      }

      // ReactGA.initialize(trackingId, { debug: true });
      // ReactGA.pageview(location.pathname + window.location.search);

      // console.log("window", window, location.pathname, "action", action);

      window.gtag("config", trackingId, {
        'page_path': location.pathname,
      });
    });

    return unlisten;
  }, [trackingId, listen]);
};
